var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5248_30020)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5248_30020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 5.05859V19.2256C18.3359 19.4464 18.2479 19.6583 18.0918 19.8145C17.9356 19.9706 17.7238 20.0586 17.5029 20.0586H2.50293C2.28204 20.0586 2.07025 19.9706 1.91406 19.8145C1.75787 19.6583 1.66992 19.4465 1.66992 19.2256V0.891602C1.66992 0.431602 2.0415 0.0585938 2.50293 0.0585938H13.3359L18.3359 5.05859Z",
    fill: "#4A8DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3301 0L18.3301 5H14.1644C14.0549 5.00019 13.9464 4.97878 13.8452 4.93701C13.744 4.89524 13.652 4.83392 13.5745 4.75657C13.497 4.67921 13.4356 4.58733 13.3936 4.48619C13.3517 4.38505 13.3301 4.27663 13.3301 4.16714V0Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23047 15.8856L4.87653 13.2361L3.38505 10.8086H4.5215L5.48764 12.4398L6.43425 10.8086H7.56136L6.06308 13.2743L7.70914 15.8856H6.53618L5.46811 14.13L4.39706 15.8856H3.23047ZM8.19498 15.8856V10.8086H9.65036L10.5252 14.2714L11.3894 10.8086H12.8482V15.8856H11.9436V11.889L10.9881 15.8856H10.0517L9.09912 11.889V15.8856H8.19498ZM13.8398 15.8856V10.84H14.8123V15.0291H17.2305V15.8861H13.8398V15.8856Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5248_30020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5248_30020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXml);
export default __webpack_public_path__ + "static/media/xml.cb896da7ecddd47469e67487bbf777ef.svg";
export { ForwardRef as ReactComponent };